// Textos de Investigación (guía 8.2). Finales: si algo se acorta por diseño, se anota en
// la bitácora.

export const research = {
  how: {
    title: "Cuatro cosas pasan antes de cada palabra.",
    steps: [
      { title: "Planifica.", body: "Arma un plan interno y lo va actualizando.", tech: "gated planning state" },
      { title: "Repasa.", body: "Pasa varias veces por el mismo bloque y refina lo que tiene.", tech: "shared recurrent block" },
      {
        title: "Se revisa.",
        body: "Estima qué tan confiable es su propio estado, y corrige con más fuerza cuando duda.",
        tech: "internal verifier · conditional repair",
      },
      { title: "Decide cuándo parar.", body: "Elige solo cuántas vueltas necesita cada palabra.", tech: "adaptive halting" },
    ],
    fine: "El bloque se llama DeliberationBlock. Es lo que diseñamos nosotros. Las piezas de base (atención, normalización, activaciones) son las estándar del campo: no inventamos cada pieza, inventamos la combinación.",
  },
  results: {
    title: "Lo que medimos.",
    chart1: {
      title: "Cuanto más piensa, menos duda.",
      caption:
        "Mismo modelo, misma prueba. De una a siete vueltas la perplejidad baja de 69,86 a 49,28. Después se estabiliza, sin empeorar. Cuando lo dejamos decidir solo, usa en promedio 7,4 vueltas de las 8 con las que fue entrenado.",
      fine: "Conjunto de prueba GSM8K en español, 192 ejemplos, no vistos en el entrenamiento.",
      control: "Vueltas de deliberación",
      replay: "Repetir",
    },
    chart2: {
      title: "El 10 % del modelo hace el 40 % del trabajo.",
      caption:
        "La deliberación es una parte chica de los parámetros y una parte grande del cómputo. Esa es la apuesta: conseguir calidad con cómputo, que abunda, en lugar de con memoria, que escasea.",
      fine: "Es la hipótesis que estamos probando, no una conclusión.",
    },
    chart3: {
      title: "Fuerte en su idioma.",
      lead: "Bits por carácter (menos es mejor), mismo texto para los dos modelos.",
      caption:
        "En español nuestro modelo comprime mejor que GPT-2 124M con unas 11 veces menos datos. En inglés, GPT-2 gana con claridad.",
      fine: "Esto muestra especialización en español (corpus y tokenizer propios), no que la arquitectura sea superior.",
    },
    chart4: {
      title: "Más español en cada token.",
      caption:
        "Nuestro tokenizer guarda 4,25 caracteres de español por token; el de GPT-2, 2,92. Un 46 % más de texto en el mismo espacio.",
    },
  },
  missing: {
    title: "Lo que falta probar.",
    body: "Falta la comparación justa: nuestra arquitectura contra un modelo convencional del mismo tamaño, con los mismos datos y el mismo presupuesto. La vamos a correr sobre el próximo modelo, no sobre este, porque en el actual el verificador quedó chico y la comparación mediría ese límite y no la idea. Hasta que esa prueba exista, no decimos que esta arquitectura le gana a una convencional.",
  },
  publication: {
    eyebrow: "Publicación",
    read: { label: "Leer el paper", href: "/paper" },
    cite: { label: "Citar", href: "/paper#citar" },
  },
  audit: { line: "Antes de decir que somos los primeros, lo comprobamos.", href: "/auditoria", label: "Auditoría" },
} as const;
